(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const isMatteLanding = main.classList.contains('theme-template-suffix-landing-matte-jolie');
  const pageLocale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  if (isMatteLanding) main.classList.add('theme-template-suffix-landing-deal-test');
  if (!isMatteLanding && !main.classList.contains('theme-template-suffix-landing-deal-test') && !main.classList.contains('theme-template-suffix-landing-outdoor-test')) return;
  const isDeal = isMatteLanding || main.classList.contains('theme-template-suffix-landing-deal-test');
  const isGloss100Deal = main.classList.contains('theme-template-suffix-deal-100-2-gloss') || /\/100-2-gloss-custom-vinyl-stickers(?:\/|$)/.test(window.location.pathname);
  const is500Deal = isDeal && /\/500-2-gloss-custom-vinyl-stickers(?:\/|$)/.test(window.location.pathname);
  const isLargeGlossDeal = isDeal && /\/50-6-gloss-custom-vinyl-stickers(?:\/|$)/.test(window.location.pathname);
  const isMatte200Deal = isDeal && /\/200-3-matte-custom-vinyl-stickers(?:\/|$)/.test(window.location.pathname);
  const isRoll1000Deal = isDeal && /\/1000-2-gloss-custom-vinyl-roll-labels(?:\/|$)/.test(window.location.pathname);
  const isCustomRollConfigurator = /\/custom-vinyl-roll-stickers-2-6gloss-matte(?:\/|$)/.test(window.location.pathname);
  const useFixedDealPrice = isGloss100Deal || isLargeGlossDeal || isRoll1000Deal;
  const dealProfile = isGloss100Deal
        ? { quantity: 100, size: 2, compare: '$30.00', saving: 'Save 50%', unit: '$0.15', unitName: 'sticker', finish: 'Premium Gloss · Included', surface: 'Waterproof gloss vinyl', fallback: '$14.99', badge: '100 PCS · 2-INCH GLOSS', bottomBadge: 'ONE DESIGN · CUSTOM CUT' }
      : isMatte200Deal
        ? { quantity: 200, size: 3, unit: '$0.25', unitName: 'sticker', finish: 'Premium Matte · Included', surface: 'Matte or Glossy vinyl finish', fallback: '$49.00', badge: '200 PCS · UP TO 3 INCH' }
    : isRoll1000Deal
      ? { quantity: 1000, size: 2, unit: '$0.10', unitName: 'label', finish: 'Premium Gloss · Roll format', surface: 'Gloss vinyl face + efficient roll format', fallback: '$99.00', badge: '1,000 PCS · 2-INCH ROLL LABELS' }
      : is500Deal
    ? { quantity: 500, size: 2, compare: '$150.00', saving: 'Save 54%', unit: '$0.14', unitName: 'sticker', finish: 'Premium Gloss · Included', surface: 'Gloss PVC face + removable adhesive', fallback: '$69.00', badge: '500 PCS · UP TO 2 INCH' }
    : isLargeGlossDeal
      ? { quantity: 50, size: 6, compare: '$135.00', saving: 'Save 56%', unit: '$1.18', unitName: 'sticker', finish: 'Premium Gloss · Included', surface: 'Gloss PVC face + removable adhesive', fallback: '$59.00', badge: '50 PCS · 6-INCH GLOSS' }
      : { quantity: 100, size: 3, compare: '$40.50', saving: 'Save 28%', unit: '$0.29', unitName: 'sticker', finish: 'Premium Gloss · Included', surface: 'Gloss PVC face + removable adhesive', fallback: '$29.00', badge: '100 PCS · UP TO 3 INCH' };

  const matte200FinishContentByLocale = {
    en: {
      Matte: {
        title: '200 Custom 3" Matte Vinyl Stickers',
        description: 'Create 200 custom 3-inch vinyl stickers with a smooth, low-reflection matte finish. Ideal for logos, packaging, promotions, events, artwork, and personal projects. Upload your design, choose a shape, and review a digital proof before production.',
        benefit: 'Matte or Glossy vinyl finish'
      },
      Glossy: {
        title: '200 Custom 3" Glossy Vinyl Stickers',
        description: 'Create 200 custom 3-inch vinyl stickers with a bright, polished glossy finish. Ideal for logos, packaging, promotions, events, artwork, and personal projects. Upload your design, choose a shape, and review a digital proof before production.',
        benefit: 'Matte or Glossy vinyl finish'
      }
    },
    fr: {
      Matte: {
        title: '200 autocollants vinyle mats personnalisés de 7,6 cm',
        description: 'Créez 200 autocollants vinyle personnalisés de 7,6 cm avec une finition mate, douce et peu réfléchissante. Idéals pour logos, emballages, promotions, événements, illustrations et projets personnels. Téléversez votre design, choisissez une forme et vérifiez le BAT numérique avant production.',
        benefit: 'Finition vinyle mate ou brillante'
      },
      Glossy: {
        title: '200 autocollants vinyle brillants personnalisés de 7,6 cm',
        description: 'Créez 200 autocollants vinyle personnalisés de 7,6 cm avec une finition brillante, lumineuse et polie. Idéals pour logos, emballages, promotions, événements, illustrations et projets personnels. Téléversez votre design, choisissez une forme et vérifiez le BAT numérique avant production.',
        benefit: 'Finition vinyle mate ou brillante'
      }
    },
    de: {
      Matte: {
        title: '200 individuelle matte 3-Zoll-Vinylaufkleber',
        description: 'Gestalten Sie 200 individuelle 3-Zoll-Vinylaufkleber mit einer glatten, reflexionsarmen matten Oberfläche. Ideal für Logos, Verpackungen, Aktionen, Events, Illustrationen und persönliche Projekte. Laden Sie Ihr Motiv hoch, wählen Sie eine Form und prüfen Sie vor der Produktion den digitalen Korrekturabzug.',
        benefit: 'Matte oder glänzende Vinyloberfläche'
      },
      Glossy: {
        title: '200 individuelle glänzende 3-Zoll-Vinylaufkleber',
        description: 'Gestalten Sie 200 individuelle 3-Zoll-Vinylaufkleber mit einer hellen, polierten Glanzoberfläche. Ideal für Logos, Verpackungen, Aktionen, Events, Illustrationen und persönliche Projekte. Laden Sie Ihr Motiv hoch, wählen Sie eine Form und prüfen Sie vor der Produktion den digitalen Korrekturabzug.',
        benefit: 'Matte oder glänzende Vinyloberfläche'
      }
    }
  };
  const matte200FinishContent = matte200FinishContentByLocale[pageLocale] || matte200FinishContentByLocale.en;
  const matte200UiByLocale = {
    en: { selectFinish: 'Select Finish', matte: 'Matte', matteDescription: 'Soft, low-reflection finish', glossy: 'Glossy', glossyDescription: 'Bright, polished finish', highlights: ['200 custom stickers', 'Up to 3 inches on the longest side', 'Matte or Glossy vinyl finish', 'Artwork checked before production'], highlightsLabel: 'Product highlights', unitNote: 'Only $0.25 per sticker', policyLabel: 'Shipping and return policies', freeShipping: 'Free Shipping', freeShippingBefore: 'Free shipping is available. For additional information, view our ', shippingPolicy: 'shipping policy', returnPolicy: 'Return Policy', returnBefore: '30-Day Money Back Guarantee. For more details, view our ', refundPolicy: 'Return & Refund Policy', helpful: 'Helpful Details Before You Order', chooseImage: 'Choose a product image', viewImage: 'View product image', moreViews: 'More Views', galleryHint: 'Choose an image or use the arrows' },
    fr: { selectFinish: 'Choisir la finition', matte: 'Mate', matteDescription: 'Finition douce et peu réfléchissante', glossy: 'Brillante', glossyDescription: 'Finition lumineuse et polie', highlights: ['200 autocollants personnalisés', 'Jusqu’à 7,6 cm sur le côté le plus long', 'Finition vinyle mate ou brillante', 'Visuel vérifié avant production'], highlightsLabel: 'Points forts du produit', unitNote: 'Seulement 0,25 $ par autocollant', policyLabel: 'Livraison et retours', freeShipping: 'Livraison gratuite', freeShippingBefore: 'La livraison gratuite est disponible. Pour en savoir plus, consultez notre ', shippingPolicy: 'politique de livraison', returnPolicy: 'Politique de retour', returnBefore: 'Garantie satisfait ou remboursé de 30 jours. Pour en savoir plus, consultez notre ', refundPolicy: 'politique de remboursement', helpful: 'Informations utiles avant de commander', chooseImage: 'Choisir une image du produit', viewImage: 'Afficher l’image du produit', moreViews: 'Plus de vues', galleryHint: 'Choisissez une image ou utilisez les flèches' },
    de: { selectFinish: 'Oberfläche wählen', matte: 'Matt', matteDescription: 'Weiche, reflexionsarme Oberfläche', glossy: 'Glänzend', glossyDescription: 'Helle, polierte Oberfläche', highlights: ['200 individuelle Aufkleber', 'Bis zu 3 Zoll an der längsten Seite', 'Matte oder glänzende Vinyloberfläche', 'Druckdatenprüfung vor der Produktion'], highlightsLabel: 'Produktvorteile', unitNote: 'Nur 0,25 $ pro Aufkleber', policyLabel: 'Versand und Rückgabe', freeShipping: 'Kostenloser Versand', freeShippingBefore: 'Kostenloser Versand ist verfügbar. Weitere Informationen finden Sie in unseren ', shippingPolicy: 'Versandbedingungen', returnPolicy: 'Rückgabebedingungen', returnBefore: '30 Tage Geld-zurück-Garantie. Weitere Informationen finden Sie in unseren ', refundPolicy: 'Rückerstattungsbedingungen', helpful: 'Wichtige Informationen vor der Bestellung', chooseImage: 'Produktbild auswählen', viewImage: 'Produktbild anzeigen', moreViews: 'Weitere Ansichten', galleryHint: 'Wählen Sie ein Bild oder verwenden Sie die Pfeile' }
  };
  const matte200Ui = matte200UiByLocale[pageLocale] || matte200UiByLocale.en;

  const helpfulDetailsByLocale = {
    en: {
      heading: 'Helpful Details Before You Order',
      designTitle: 'Design Tips',
      resolution: (size) => `Prepare artwork at 300 DPI at the final print size (up to ${size} inches on the longest side).`,
      color: 'Use CMYK color mode when possible. Screen color can differ slightly from printed color.',
      detail: 'Keep small text, fine lines, borders, and narrow cut areas thick enough to print and apply cleanly.',
      proofTip: 'Review spelling, scale, color, border, and cut shape carefully on the digital proof.',
      artworkTitle: 'Artwork & Digital Proof',
      artworkBody: 'Upload one design using the highest-quality file available. We check print readiness and send a digital proof before production begins.',
      shippingTitle: 'Free Shipping',
      shippingBefore: 'Free shipping is available. Delivery timing begins after proof approval and production. Review our ',
      shippingLink: 'shipping policy',
      returnsTitle: 'Return Policy',
      returnsBefore: 'This item is custom-made. If it arrives defective, damaged, incorrect, missing, or materially different from the approved proof, review our ',
      returnsLink: 'Return & Refund Policy',
      returnsAfter: ' for eligibility and next steps.'
    },
    fr: {
      heading: 'Informations utiles avant de commander',
      designTitle: 'Conseils pour votre design',
      resolution: (size) => `Préparez votre fichier à 300 ppp à la taille finale d'impression (jusqu'à ${size} pouces sur le côté le plus long).`,
      color: 'Utilisez le mode colorimétrique CMJN si possible. Les couleurs à l’écran peuvent légèrement différer à l’impression.',
      detail: 'Prévoyez une épaisseur suffisante pour les petits textes, les traits fins, les bordures et les zones de découpe étroites.',
      proofTip: 'Vérifiez attentivement l’orthographe, l’échelle, les couleurs, la bordure et la forme de découpe sur le BAT numérique.',
      artworkTitle: 'Fichier et BAT numérique',
      artworkBody: 'Téléversez un seul design dans la meilleure qualité disponible. Nous vérifions le fichier et envoyons un BAT numérique avant le début de la production.',
      shippingTitle: 'Livraison gratuite',
      shippingBefore: 'La livraison gratuite est disponible. Le délai de livraison commence après l’approbation du BAT et la production. Consultez notre ',
      shippingLink: 'politique de livraison',
      returnsTitle: 'Politique de retour',
      returnsBefore: 'Cet article est fabriqué sur mesure. S’il arrive défectueux, endommagé, incorrect, incomplet ou sensiblement différent du BAT approuvé, consultez notre ',
      returnsLink: 'politique de retour et de remboursement',
      returnsAfter: ' pour connaître les conditions et la marche à suivre.'
    },
    de: {
      heading: 'Wichtige Informationen vor der Bestellung',
      designTitle: 'Tipps für Druckdaten',
      resolution: (size) => `Legen Sie die Druckdatei in Endgröße mit 300 dpi an (bis zu ${size} Zoll an der längsten Seite).`,
      color: 'Verwenden Sie nach Möglichkeit den CMYK-Farbmodus. Bildschirmfarben können leicht vom Druckergebnis abweichen.',
      detail: 'Achten Sie darauf, dass kleine Schrift, feine Linien, Ränder und schmale Schnittbereiche stark genug angelegt sind.',
      proofTip: 'Prüfen Sie Rechtschreibung, Größe, Farbe, Rand und Schnittform sorgfältig im digitalen Korrekturabzug.',
      artworkTitle: 'Druckdatei & Korrekturabzug',
      artworkBody: 'Laden Sie ein Motiv in der bestmöglichen Qualität hoch. Wir prüfen die Druckfähigkeit und senden vor Produktionsbeginn einen digitalen Korrekturabzug.',
      shippingTitle: 'Kostenloser Versand',
      shippingBefore: 'Kostenloser Versand ist verfügbar. Die Lieferzeit beginnt nach Freigabe des Korrekturabzugs und der Produktion. Lesen Sie unsere ',
      shippingLink: 'Versandbedingungen',
      returnsTitle: 'Rückgabebedingungen',
      returnsBefore: 'Dieser Artikel wird individuell angefertigt. Falls er fehlerhaft, beschädigt, falsch, unvollständig oder deutlich anders als der freigegebene Korrekturabzug ankommt, lesen Sie unsere ',
      returnsLink: 'Rückgabe- und Erstattungsbedingungen',
      returnsAfter: ' zu Voraussetzungen und nächsten Schritten.'
    }
  };
  const helpfulDetailsUi = isMatte200Deal
    ? (helpfulDetailsByLocale[pageLocale] || helpfulDetailsByLocale.en)
    : helpfulDetailsByLocale.en;

  const helpfulDetailIcons = {
    design: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18h6M10 22h4M8.3 15.7A7 7 0 1 1 15.7 15.7C14.8 16.5 14.5 17.2 14.5 18h-5c0-.8-.3-1.5-1.2-2.3Z"/><path d="m9.5 10.5 1.7 1.7 3.3-3.6"/></svg>',
    artwork: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 3h11l5 5v13H4z"/><path d="M14 3v6h6M8 14h8M8 18h5"/><path d="m7.5 9 1.4 1.4L12 7.3"/></svg>',
    shipping: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v11H3zM14 10h4l3 4v3h-7z"/><circle cx="7" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>',
    returns: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 7H3V2"/><path d="M3.5 7.5A9 9 0 1 1 3 16"/><path d="M12 7v10M15 9.5c-.8-.8-1.8-1.2-3-1.2-1.6 0-2.8.8-2.8 2 0 3.1 5.6 1.2 5.6 4.3 0 1.2-1.2 2.1-2.8 2.1-1.3 0-2.4-.5-3.2-1.4"/></svg>'
  };

  const enhanceCalculator = () => {
    const calculator = main.querySelector('#calculator');
    if (!calculator) return;

    calculator.setAttribute('translate', 'no');
    if (isCustomRollConfigurator && calculator.dataset.ipDefaultGlossApplied !== 'true') {
      const none = calculator.querySelector('input[name="properties[Select Finish]"][value="None"]');
      const gloss = calculator.querySelector('input[name="properties[Select Finish]"][value="Gloss"]');
      if (gloss && (!none || none.checked)) {
        if (none) none.checked = false;
        gloss.checked = true;
        gloss.dispatchEvent(new Event('change', { bubbles: true }));
      }
      calculator.dataset.ipDefaultGlossApplied = 'true';
    }
    calculator.querySelectorAll('a[href*="support.custompricecalculator.com"]').forEach((link) => {
      if (link.textContent.trim().toLowerCase() === 'here') {
        link.textContent = 'calculator troubleshooting guide';
      }
    });
    calculator.querySelectorAll('.checkbox-element').forEach((group) => {
      group.querySelectorAll(':scope > input.radio').forEach((input) => {
        const text = input.nextElementSibling;
        if (!text || text.tagName !== 'SPAN') return;

        const choice = document.createElement('label');
        choice.className = 'ip-option-choice';
        input.before(choice);
        choice.append(input, text);
      });
    });
  };

  const enhanceShapePicker = () => {
    const calculator = main.querySelector('#calculator');
    if (!calculator) return;

    const shapeInputs = Array.from(calculator.querySelectorAll('input[type="radio"]')).filter((input) =>
      input.dataset.calcname === 'Select Shape' || input.dataset.identifier === 'Select Shape'
    );
    if (!shapeInputs.length) return;

    const picker = shapeInputs[0].closest('fieldset.swatch-picker');
    if (!picker) return;

    picker.classList.add('ip-shape-picker');
    picker.setAttribute('aria-label', 'Choose Your Shape');

    const field = picker.closest('.element');
    const fieldLabel = field?.querySelector('.element-label');
    if (fieldLabel && fieldLabel.textContent.trim() !== 'Choose Your Shape') fieldLabel.textContent = 'Choose Your Shape';

    const labelMap = {
      custom: 'Custom Shape',
      circle: 'Circle',
      square: 'Square',
      'round-square': 'Round Square',
      'round-rectangle': 'Round Rectangle',
      rectangle: 'Rectangle',
      oval: 'Oval'
    };
    const orderMap = {
      custom: 1,
      circle: 2,
      square: 3,
      oval: 4,
      'round-square': 5,
      'round-rectangle': 6,
      rectangle: 7
    };

    shapeInputs.forEach((input, index) => {
      const shape = input.value.trim().toLowerCase().replace(/\s+/g, '-');
      const label = labelMap[shape] || input.value;
      const card = input.closest('.swatch-label');
      if (!card) return;

      card.classList.add('ip-shape-card', `ip-shape-card--${shape}`);
      card.style.setProperty('--ip-shape-order', String(orderMap[shape] || index + 10));
      input.setAttribute('aria-label', label);

      const sourceImage = card.querySelector('img');
      if (sourceImage) {
        sourceImage.alt = '';
        sourceImage.setAttribute('aria-hidden', 'true');
      }

      if (!card.querySelector('.ip-shape-icon')) {
        const icon = document.createElement('span');
        icon.className = 'ip-shape-icon';
        icon.setAttribute('aria-hidden', 'true');
        const name = document.createElement('span');
        name.className = 'ip-shape-name';
        name.textContent = label;
        card.append(icon, name);
      }
    });

    if (isDeal && !isMatte200Deal && !picker.nextElementSibling?.classList.contains('ip-shape-finish')) {
      const finish = document.createElement('p');
      finish.className = 'ip-shape-finish';
      const finishValue = document.createElement('strong');
      finishValue.textContent = dealProfile.finish;
      finish.append('Finish: ', finishValue);
      picker.after(finish);
    }
  };

  const enhanceFinishPicker = () => {
    if (!isMatte200Deal) return;

    const calculator = main.querySelector('#calculator');
    const form = main.querySelector('.section-product-info form[data-type="add-to-cart-form"]');
    const shapePicker = calculator?.querySelector('.ip-shape-picker');
    const shapeField = shapePicker?.closest('.element');
    if (!calculator || !form || !shapeField) return;

    let propertyInput = form.querySelector('[data-ip-finish-property]');
    if (!propertyInput) {
      propertyInput = document.createElement('input');
      propertyInput.type = 'hidden';
      propertyInput.name = 'properties[Finish]';
      propertyInput.value = 'Matte';
      propertyInput.dataset.ipFinishProperty = 'true';
      form.append(propertyInput);
    }

    if (calculator.querySelector('.ip-finish-picker')) return;

    const picker = document.createElement('fieldset');
    picker.className = 'ip-finish-picker';
    picker.setAttribute('aria-label', matte200Ui.selectFinish);

    const legend = document.createElement('legend');
    legend.textContent = matte200Ui.selectFinish;
    picker.append(legend);

    const options = [
      ['Matte', matte200Ui.matte, matte200Ui.matteDescription],
      ['Glossy', matte200Ui.glossy, matte200Ui.glossyDescription]
    ];

    const applyFinish = (finish) => {
      const copy = matte200FinishContent[finish] || matte200FinishContent.Matte;
      propertyInput.value = finish;
      main.dataset.selectedFinish = finish.toLowerCase();

      picker.querySelectorAll('.ip-finish-option').forEach((option) => {
        option.classList.toggle('is-selected', option.dataset.finish === finish);
        const input = option.querySelector('input');
        if (input) input.checked = option.dataset.finish === finish;
      });

      const title = main.querySelector('.section-product-info .x-block-product-title h1, .section-product-info .x-block-product-title h2');
      if (title) title.textContent = copy.title;

      const description = main.querySelector('.section-product-info .x-block-description .rte');
      if (description) {
        const paragraph = document.createElement('p');
        paragraph.textContent = copy.description;
        description.replaceChildren(paragraph);
        description.setAttribute('aria-live', 'polite');
      }

      const benefit = main.querySelector('.section-product-info .ip-hero-benefits li:nth-child(3)');
      if (benefit) {
        const check = benefit.querySelector('span');
        benefit.replaceChildren();
        if (check) benefit.append(check);
        benefit.append(document.createTextNode(copy.benefit));
      }

      const stickyTitle = main.querySelector('.ink-jolie-matte__sticky strong');
      if (stickyTitle) stickyTitle.textContent = copy.title;
      document.title = `${copy.title} – Inkelligent`;

      main.dispatchEvent(new CustomEvent('inkelligent:finish-change', {
        bubbles: true,
        detail: { finish }
      }));
    };

    options.forEach(([finish, displayName, description]) => {
      const option = document.createElement('label');
      option.className = 'ip-finish-option';
      option.dataset.finish = finish;

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'ip-finish-choice';
      input.value = finish;
      input.checked = finish === 'Matte';
      input.setAttribute('aria-label', `${finish}: ${description}`);

      const swatch = document.createElement('span');
      swatch.className = `ip-finish-option__swatch ip-finish-option__swatch--${finish.toLowerCase()}`;
      swatch.setAttribute('aria-hidden', 'true');

      const copy = document.createElement('span');
      copy.className = 'ip-finish-option__copy';
      const name = document.createElement('strong');
      name.textContent = displayName;
      const detail = document.createElement('small');
      detail.textContent = description;
      copy.append(name, detail);

      input.addEventListener('change', () => {
        if (input.checked) applyFinish(finish);
      });

      option.append(input, swatch, copy);
      picker.append(option);
    });

    shapeField.before(picker);
    picker.parentElement?.classList.add('ip-customization-panel');
    applyFinish(propertyInput.value || 'Matte');
  };

  const syncHeroPrice = () => {
    const priceSummary = main.querySelector('.section-product-info .ip-price-summary');
    const summaryPrice = priceSummary?.querySelector('.ip-price-summary__current');
    if (!priceSummary || !summaryPrice) return;

    const calculatorPrice = useFixedDealPrice ? '' : main.querySelector('#calculator-final-value')?.textContent?.trim();
    const themePrice = main.querySelector('.main-product-price .price-sale')?.textContent?.trim();
    const nextPrice = (useFixedDealPrice ? dealProfile.fallback : (calculatorPrice || themePrice || (isDeal ? dealProfile.fallback : '')))
      .replace(/\$\s+/, '$')
      .replace(/\s*USD$/i, '');

    if (nextPrice && summaryPrice.textContent !== nextPrice) summaryPrice.textContent = nextPrice;
    priceSummary.hidden = !nextPrice;
  };

  let priceSyncFrame = 0;
  let priceSyncTimer = 0;
  const queuePriceSync = () => {
    if (!priceSyncFrame) {
      priceSyncFrame = window.requestAnimationFrame(() => {
        priceSyncFrame = 0;
        syncHeroPrice();
      });
    }
    window.clearTimeout(priceSyncTimer);
    priceSyncTimer = window.setTimeout(syncHeroPrice, 160);
  };

  const bindCalculatorPriceSync = () => {
    const calculator = main.querySelector('#calculator');
    if (!calculator) return;

    if (!calculator.dataset.ipPriceSyncBound) {
      calculator.addEventListener('input', queuePriceSync);
      calculator.addEventListener('change', queuePriceSync);
      calculator.dataset.ipPriceSyncBound = 'true';
    }

    const finalValue = calculator.querySelector('#calculator-final-value');
    if (finalValue && !finalValue.dataset.ipPriceObserverBound) {
      const priceObserver = new MutationObserver(queuePriceSync);
      priceObserver.observe(finalValue, { childList: true, characterData: true, subtree: true });
      finalValue.dataset.ipPriceObserverBound = 'true';
    }

    queuePriceSync();
  };

  const enhanceHero = () => {
    const info = main.querySelector('.section-product-info .product-info > .flex');
    const buyBlock = info?.querySelector('.x-block-buy-buttons');

    const reviewBlock = info?.querySelector('.x-review-product');
    if (reviewBlock && /\(\s*0\s*\)/.test(reviewBlock.textContent || '')) {
      reviewBlock.hidden = true;
    }

    if (isMatte200Deal && info && main.dataset.ipDefaultFinishCopy !== 'true') {
      const copy = matte200FinishContent.Matte;
      const title = info.querySelector('.x-block-product-title h1, .x-block-product-title h2');
      const description = info.querySelector('.x-block-description .rte');
      const form = info.querySelector('form[data-type="add-to-cart-form"]');

      if (title) title.textContent = copy.title;
      if (description) {
        const paragraph = document.createElement('p');
        paragraph.textContent = copy.description;
        description.replaceChildren(paragraph);
        description.setAttribute('aria-live', 'polite');
      }

      if (form && !form.querySelector('[data-ip-finish-property]')) {
        const propertyInput = document.createElement('input');
        propertyInput.type = 'hidden';
        propertyInput.name = 'properties[Finish]';
        propertyInput.value = 'Matte';
        propertyInput.dataset.ipFinishProperty = 'true';
        form.append(propertyInput);
      }

      document.title = `${copy.title} – Inkelligent`;
      main.dataset.ipDefaultFinishCopy = 'true';
    }

    if (info && buyBlock && !info.querySelector('.ip-hero-benefits')) {
      info.classList.add('ip-hero-info');
      const benefits = isMatte200Deal
        ? matte200Ui.highlights
        : main.classList.contains('theme-template-suffix-landing-outdoor-test')
        ? ['Waterproof vinyl face stock', 'Made for compatible outdoor surfaces', 'Custom size, quantity & shape', 'Artwork checked before production']
        : isRoll1000Deal
          ? [`${dealProfile.quantity.toLocaleString()} custom roll labels`, `${dealProfile.size}-inch label size`, dealProfile.surface, 'Artwork checked before production']
          : [`${dealProfile.quantity} custom stickers`, `Up to ${dealProfile.size} inches on the longest side`, dealProfile.surface, 'Artwork checked before production'];
      const list = document.createElement('ul');
      list.className = 'ip-hero-benefits';
      list.setAttribute('aria-label', isMatte200Deal ? matte200Ui.highlightsLabel : 'Product highlights');
      benefits.forEach((benefit) => {
        const item = document.createElement('li');
        const check = document.createElement('span');
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        item.append(check, document.createTextNode(benefit));
        list.append(item);
      });
      buyBlock.before(list);
    }

    if (info && buyBlock && !info.querySelector('.ip-price-summary')) {
      const priceSummary = document.createElement('div');
      priceSummary.className = 'ip-price-summary';
      priceSummary.setAttribute('aria-live', 'polite');

      const priceLine = document.createElement('div');
      priceLine.className = 'ip-price-summary__line';
      const currentPrice = document.createElement('strong');
      currentPrice.className = 'ip-price-summary__current';
      priceLine.append(currentPrice);

      if (isDeal && dealProfile.compare && dealProfile.saving) {
        const comparePrice = document.createElement('s');
        comparePrice.className = 'ip-price-summary__compare';
        comparePrice.textContent = dealProfile.compare;
        const saving = document.createElement('span');
        saving.className = 'ip-price-summary__saving';
        saving.textContent = dealProfile.saving;
        priceLine.append(comparePrice, saving);
      }

      const note = document.createElement('p');
      note.className = 'ip-price-summary__note';
      note.textContent = isMatte200Deal
        ? matte200Ui.unitNote
        : isDeal
        ? `Only ${dealProfile.unit} per ${dealProfile.unitName}`
        : 'Price updates with your size, quantity, and finish';

      priceSummary.append(priceLine, note);
      const description = info.querySelector('.x-block-description');
      if (description) description.before(priceSummary);
      else buyBlock.before(priceSummary);
    }

    syncHeroPrice();
    bindCalculatorPriceSync();

    if (isMatte200Deal && info && buyBlock) {
      const estimateDelivery = info.querySelector('.x-block-estimate-delivery');
      if (estimateDelivery) {
        estimateDelivery.hidden = true;
        estimateDelivery.setAttribute('aria-hidden', 'true');
        estimateDelivery.classList.add('ip-policy-replaced');
      }

      info.querySelector('.ip-checkout-confidence')?.remove();
    }

    if (!isMatte200Deal && info && buyBlock && !info.querySelector('.ip-checkout-confidence')) {
      const confidence = document.createElement('ul');
      confidence.className = 'ip-checkout-confidence';
      confidence.setAttribute('aria-label', 'Order assurances');

      const assurances = [
        ['Artwork checked before production', ''],
        ['Free shipping', '/policies/shipping-policy'],
        ['30-day guarantee', '/policies/refund-policy']
      ];
      assurances.forEach(([label, href]) => {
        const item = document.createElement('li');
        const check = document.createElement('span');
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        item.append(check);
        if (href) {
          const link = document.createElement('a');
          link.href = href;
          link.textContent = label;
          item.append(link);
        } else {
          item.append(document.createTextNode(label));
        }
        confidence.append(item);
      });
      buyBlock.after(confidence);
    }

    const heroShell = main.querySelector('.section-product-info .page-width.flex');
    const productSection = heroShell?.closest('.section-product-info');
    const sourceSupportBlocks = info
      ? Array.from(info.querySelectorAll('.accordion, .custom-html, .x-block-social-sharing, .ip-order-policies'))
      : [];
    sourceSupportBlocks.forEach((block) => block.remove());

    if (heroShell && productSection) {
      let support = productSection.querySelector('.ip-after-hero-support');
      if (!support) {
        support = document.createElement('section');
        support.className = 'ip-after-hero-support';
        support.setAttribute('aria-labelledby', 'ip-after-hero-title');
        heroShell.after(support);
      }

      if (support.dataset.ipComplete !== 'true') {
        const makeCard = ({ type, title, body, items, link }) => {
          const card = document.createElement('article');
          card.className = `ip-helpful-card ip-helpful-card--${type}`;

          const header = document.createElement('div');
          header.className = 'ip-helpful-card__header';
          const icon = document.createElement('span');
          icon.className = 'ip-helpful-card__icon';
          icon.innerHTML = helpfulDetailIcons[type];
          const cardTitle = document.createElement('h3');
          cardTitle.textContent = title;
          header.append(icon, cardTitle);
          card.append(header);

          if (items) {
            const list = document.createElement('ol');
            list.className = 'ip-helpful-card__list';
            items.forEach((itemText) => {
              const item = document.createElement('li');
              item.textContent = itemText;
              list.append(item);
            });
            card.append(list);
          } else {
            const paragraph = document.createElement('p');
            paragraph.append(body);
            if (link) {
              const anchor = document.createElement('a');
              anchor.href = link.href;
              anchor.textContent = link.label;
              paragraph.append(anchor, link.after || '.');
            }
            card.append(paragraph);
          }

          return card;
        };

        const heading = document.createElement('h2');
        heading.id = 'ip-after-hero-title';
        heading.textContent = helpfulDetailsUi.heading;

        const grid = document.createElement('div');
        grid.className = 'ip-helpful-grid';
        grid.append(
          makeCard({
            type: 'design',
            title: helpfulDetailsUi.designTitle,
            items: [
              helpfulDetailsUi.resolution(dealProfile.size),
              helpfulDetailsUi.color,
              helpfulDetailsUi.detail,
              helpfulDetailsUi.proofTip
            ]
          }),
          makeCard({
            type: 'artwork',
            title: helpfulDetailsUi.artworkTitle,
            body: helpfulDetailsUi.artworkBody
          }),
          makeCard({
            type: 'shipping',
            title: helpfulDetailsUi.shippingTitle,
            body: helpfulDetailsUi.shippingBefore,
            link: { href: '/policies/shipping-policy', label: helpfulDetailsUi.shippingLink }
          }),
          makeCard({
            type: 'returns',
            title: helpfulDetailsUi.returnsTitle,
            body: helpfulDetailsUi.returnsBefore,
            link: {
              href: '/policies/refund-policy',
              label: helpfulDetailsUi.returnsLink,
              after: helpfulDetailsUi.returnsAfter
            }
          })
        );

        support.replaceChildren(heading, grid);
        support.dataset.ipComplete = 'true';
      }
    }

    const gallery = main.querySelector('.section-product-info .swiper-product');
    if (gallery && !gallery.querySelector('.ip-gallery-badge')) {
      const topBadge = document.createElement('span');
      topBadge.className = 'ip-gallery-badge ip-gallery-badge--top';
      topBadge.textContent = main.classList.contains('theme-template-suffix-landing-outdoor-test') ? 'CUSTOM · WEATHER-READY' : dealProfile.badge;
      topBadge.setAttribute('aria-hidden', 'true');
      const bottomBadge = document.createElement('span');
      bottomBadge.className = 'ip-gallery-badge ip-gallery-badge--bottom';
      bottomBadge.textContent = dealProfile.bottomBadge || 'YOUR DESIGN · YOUR SHAPE';
      bottomBadge.setAttribute('aria-hidden', 'true');
      gallery.append(topBadge, bottomBadge);
      if (is500Deal) {
        const discountBadge = document.createElement('span');
        discountBadge.className = 'ip-gallery-badge ip-gallery-badge--discount';
        discountBadge.textContent = 'SAVE 54%';
        discountBadge.setAttribute('aria-hidden', 'true');
        gallery.append(discountBadge);
      }
    }

    const thumbnailRail = main.querySelector('.section-product-info [id^="x-product-thumbnail-"]');
    if (gallery && thumbnailRail) {
      thumbnailRail.setAttribute('aria-label', isMatte200Deal ? matte200Ui.chooseImage : 'Choose a product image');
      thumbnailRail.querySelectorAll('button').forEach((button, index) => {
        button.setAttribute('aria-label', `${isMatte200Deal ? matte200Ui.viewImage : 'View product image'} ${index + 1}`);
      });

      const galleryLayout = gallery.closest('.splide-image');
      if (galleryLayout && !galleryLayout.querySelector('.ip-gallery-rail-header')) {
        const railHeader = document.createElement('div');
        railHeader.className = 'ip-gallery-rail-header';
        const label = document.createElement('strong');
        label.textContent = isMatte200Deal ? matte200Ui.moreViews : 'More Views';
        const hint = document.createElement('span');
        hint.textContent = isMatte200Deal ? matte200Ui.galleryHint : 'Choose an image or use the arrows';
        railHeader.append(label, hint);
        thumbnailRail.before(railHeader);
      }
    }
  };

  const initShowcaseCarousel = (carousel) => {
      if (carousel.dataset.ipShowcaseReady === 'true') return;

      const shell = carousel.closest('.ip-shell');
      const track = carousel.querySelector('[data-ip-showcase-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-ip-showcase-slide]'));
      const previous = shell?.querySelector('[data-ip-showcase-prev]');
      const next = shell?.querySelector('[data-ip-showcase-next]');
      const status = carousel.querySelector('[data-ip-showcase-status]');
      if (!track || !slides.length || !previous || !next) return;

      carousel.dataset.ipShowcaseReady = 'true';
      let activeIndex = 0;
      let autoplayTimer;
      let scrollTimer;
      const autoplayEnabled = carousel.dataset.autoplay !== 'false';
      const interval = Math.max(3000, Number(carousel.dataset.interval) || 5000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const visibleCount = () => {
        const firstWidth = slides[0]?.getBoundingClientRect().width || track.clientWidth;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return Math.max(1, Math.floor((track.clientWidth + gap) / (firstWidth + gap)));
      };

      const maxIndex = () => Math.max(0, slides.length - visibleCount());

      const updateStatus = () => {
        if (status) status.textContent = `Showing showcase item ${activeIndex + 1} of ${slides.length}`;
      };

      const goTo = (index, smooth = true) => {
        const maximum = maxIndex();
        activeIndex = index > maximum ? 0 : index < 0 ? maximum : index;
        const target = slides[activeIndex];
        if (!target) return;
        track.scrollTo({
          left: Math.max(0, target.offsetLeft - track.offsetLeft),
          behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto'
        });
        updateStatus();
      };

      const stopAutoplay = () => window.clearInterval(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || reduceMotion.matches || maxIndex() === 0 || document.hidden) return;
        autoplayTimer = window.setInterval(() => goTo(activeIndex + 1), interval);
      };

      const refresh = () => {
        const maximum = maxIndex();
        const canMove = maximum > 0;
        previous.hidden = !canMove;
        next.hidden = !canMove;
        if (activeIndex > maximum) goTo(maximum, false);
        startAutoplay();
      };

      previous.addEventListener('click', () => {
        goTo(activeIndex - 1);
        startAutoplay();
      });
      next.addEventListener('click', () => {
        goTo(activeIndex + 1);
        startAutoplay();
      });

      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const trackLeft = track.offsetLeft + track.scrollLeft;
          activeIndex = slides.reduce((closestIndex, slide, index) => {
            const currentDistance = Math.abs(slide.offsetLeft - trackLeft);
            const closestDistance = Math.abs(slides[closestIndex].offsetLeft - trackLeft);
            return currentDistance < closestDistance ? index : closestIndex;
          }, 0);
          activeIndex = Math.min(activeIndex, maxIndex());
          updateStatus();
        }, 100);
      }, { passive: true });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) startAutoplay();
      });
      carousel.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', stopAutoplay);
        video.addEventListener('pause', startAutoplay);
        video.addEventListener('ended', startAutoplay);
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
      window.addEventListener('resize', refresh, { passive: true });
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', refresh);

      updateStatus();
      window.requestAnimationFrame(refresh);
  };

  const showcaseObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          showcaseObserver.unobserve(entry.target);
          initShowcaseCarousel(entry.target);
        });
      }, { rootMargin: '400px 0px' })
    : null;

  const enhanceShowcase = () => {
    main.querySelectorAll('[data-ip-showcase-carousel]').forEach((carousel) => {
      if (carousel.dataset.ipShowcaseReady === 'true' || carousel.dataset.ipShowcaseObserved === 'true') return;
      if (!showcaseObserver) {
        initShowcaseCarousel(carousel);
        return;
      }

      carousel.dataset.ipShowcaseObserved = 'true';
      showcaseObserver.observe(carousel);
    });
  };

  const enhanceReviewAccessibility = () => {
    let updatedButtons = 0;
    main.querySelectorAll('.jm-media-grid').forEach((grid) => {
      grid.setAttribute('role', 'tablist');
      grid.querySelectorAll('.jm-media-grid__item[aria-selected]').forEach((button) => {
        button.setAttribute('role', 'tab');
        updatedButtons += 1;
      });
    });
    return updatedButtons > 0;
  };

  let enhancementFrame = 0;
  let calculatorObserver;
  const runEnhancements = () => {
    enhancementFrame = 0;
    enhanceCalculator();
    enhanceShapePicker();
    enhanceHero();
    enhanceFinishPicker();
    enhanceShowcase();

    const calculator = main.querySelector('#calculator');
    const finalValue = calculator?.querySelector('#calculator-final-value');
    if (calculator?.querySelector('.ip-shape-picker') && finalValue?.dataset.ipPriceObserverBound === 'true') {
      calculatorObserver?.disconnect();
    }
  };
  const scheduleEnhancements = () => {
    if (enhancementFrame) return;
    enhancementFrame = window.requestAnimationFrame(runEnhancements);
  };

  scheduleEnhancements();
  calculatorObserver = new MutationObserver((mutations) => {
    const calculatorChanged = mutations.some((mutation) => {
      const target = mutation.target;
      if (target.nodeType === 1 && (target.id === 'calculator' || target.closest?.('#calculator'))) return true;
      return Array.from(mutation.addedNodes).some((node) =>
        node.nodeType === 1 && (node.id === 'calculator' || node.querySelector?.('#calculator'))
      );
    });
    if (calculatorChanged) scheduleEnhancements();
  });
  calculatorObserver.observe(main, { childList: true, subtree: true });
  window.setTimeout(() => calculatorObserver.disconnect(), 15000);

  if (!enhanceReviewAccessibility()) {
    const reviewObserver = new MutationObserver((mutations) => {
      const reviewChanged = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches?.('.jm-media-grid, .jm-media-grid__item') || node.querySelector?.('.jm-media-grid, .jm-media-grid__item'))
        )
      );
      if (reviewChanged && enhanceReviewAccessibility()) reviewObserver.disconnect();
    });
    reviewObserver.observe(main, { childList: true, subtree: true });
    window.setTimeout(() => reviewObserver.disconnect(), 15000);
  }

  document.addEventListener('shopify:section:load', scheduleEnhancements);
})();
